import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pbg-trivia-rules',
  templateUrl: './trivia-rules.component.html',
  styleUrls: ['./trivia-rules.component.scss']
})
export class TriviaRulesComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
